'use strict';
const angular = require('angular');
import { extendedCRUDMethods } from "./extendedCRUDMethods";

export default function ConfigurationsResource($resource) {
    'ngInject';
    return $resource('/api/configurations/:id', { id: '@id' }, extendedCRUDMethods);
}



// WEBPACK FOOTER //
// ./client/components/resources/configurations.resource.ts